import React from 'react';
import { X } from 'lucide-react';

/**
 * AWS Regions Settings Modal Component
 */
const AwsRegionsSettings = ({ 
  showSettingsModal, 
  setShowSettingsModal, 
  awsRegions, 
  selectedRegions, 
  toggleRegion, 
  saveRegions, 
  isLoading,
  error 
}) => {
  if (!showSettingsModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">AWS Region Settings</h2>
          <button 
            onClick={() => setShowSettingsModal(false)} 
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={20} />
          </button>
        </div>
        
        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
            {error}
          </div>
        )}
        
        <p className="text-gray-700 mb-4">
          Select the AWS regions where your infrastructure is deployed. Security tests will be run against resources in these regions.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-6">
          {awsRegions.map(region => (
            <div key={region.id} className="flex items-center">
              <input
                type="checkbox"
                id={`region-${region.id}`}
                checked={selectedRegions.includes(region.id)}
                onChange={() => toggleRegion(region.id)}
                className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
              />
              <label htmlFor={`region-${region.id}`} className="ml-2 text-sm text-gray-700">
                {region.name} <span className="text-gray-500">({region.id})</span>
              </label>
            </div>
          ))}
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => setShowSettingsModal(false)}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={saveRegions}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save Settings'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AwsRegionsSettings;
